import { useApiMutation } from "./use-api-mutation";
import { useQueryClient } from "@tanstack/react-query";

export default function useDeactivateSizingExperiment(shopId: string) {
	const queryClient = useQueryClient();

	return useApiMutation(
		"post",
		"/shops/{shopId}/sizing/experiments/{experimentId}/deactivate",
		{
			invalidate: () => {
				queryClient.invalidateQueries({
					queryKey: ["get", "/shops/{shopId}/sizing/experiments"],
				});
			},
			mapVariables: (variables: { experimentId: string }) => ({
				params: {
					path: { shopId, experimentId: variables.experimentId },
				},
			}),
		},
	);
}
